import { render, staticRenderFns } from "./NativeLesson.vue?vue&type=template&id=71edc13f&"
import script from "./NativeLesson.vue?vue&type=script&lang=js&"
export * from "./NativeLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports